module.exports = __webpack_public_path__ + "img/illust_certificate@3x.812a8aa9.png";